import request from "graphql-request";
import { CULTURES_QUERY } from "@/features/shared/api/cultures-query";
import { CultureRoot } from "@/features/shared/types/culture-types";
import { useConfigStore } from "@/store/use-config-store";

export const getCultures = async (): Promise<CultureRoot> => {
  const configState = useConfigStore?.getState();
  if (!configState?.settings?.shopApiUri) {
    throw new Error("Shop API URI is not configured.");
  }
  const shopApiUri = configState.settings.shopApiUri;

  if (!shopApiUri) {
    throw new Error("shopApiUri is not configured");
  }

  const url = `${shopApiUri}/graphql`;

  try {
    return await request(url, CULTURES_QUERY);
  } catch (error) {
    console.error("GraphQL request failed:", error);
    throw error;
  }
};
